import { useState, useEffect } from 'react';
import { News as NewsPortal } from '@uaveiro/ui';
import { withPortalProviders } from 'modules/utils';
import { CancelToken, isCancel } from 'axios';
import { queryNews } from 'services/requests';
import cleanDeep from 'clean-deep';
import queryString from 'query-string';
import { useParams } from 'react-router-dom'

const News = ({
  featured = null,
  channel = null,
  recordsPerPage = null,
  categoriesToIgnore = null,
  categories = null,
  tag = null,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [listNews, setListNews] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const { lang } = useParams()

  useEffect(() => {
    const dirty = {
      featured, channel, recordsPerPage, categoriesToIgnore, categories, tag, language: lang
    };
    const params = cleanDeep(dirty)
    const query = queryString.stringify(params)

    const source = CancelToken.source();
    const getNewsData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await queryNews(query);
        const newsItems = response.data.data.listNews;
        setListNews(newsItems);
        setLoading(false);
      } catch (err) {
        const cancelled = isCancel(err);
        if (!cancelled) {
          setLoading(false);
          setError(err);
          setListNews([]);
        }
      }
    };
    if (featured || channel || recordsPerPage || categoriesToIgnore || categories || tag) {
      getNewsData()
    }
    return () => {
      // cleanup function that cancels pending requests
      source.cancel();
    };
  }, [featured, channel, recordsPerPage, categoriesToIgnore, categories, tag, lang]);
  return withPortalProviders(NewsPortal, {
    ...props, hasError: error, loading, data: { listNews }
  });
};
export default News;
